import UserListPage from './UserListPage';

export default UserListPage;
